import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PerfilesService } from '../../../../services/perfiles/perfiles.service';

@Component({
  selector: 'app-ofertas-configuracion',
  templateUrl: './ofertas-configuracion.component.html',
  styleUrls: ['./ofertas-configuracion.component.scss']
})
export class OfertasConfiguracionComponent implements OnInit {

  showBeneficios: boolean = false;
  showCategorias: boolean = false;

  constructor(
      private perfilesService: PerfilesService,
      private router: Router,
  ) { }

  ngOnInit(): void {
    this.perfilesService.allowedByUserLogon(this.router.url);
  }

  toggleBeneficios(): void {
    this.showBeneficios = !this.showBeneficios;
    this.showCategorias = false;
  }

  toggleCategorias(): void {
    this.showCategorias = !this.showCategorias;
    this.showBeneficios = false;
  }

}
